<template>
  <ul class="captions d-flex justify-md-center flex-wrap pt-4 text-sm-subtitle-1 text-caption">
    <li v-for="item in statuses" :key="item.look" class="d-flex justify-center align-center px-4 pt-2 pt-md-0">
      <div class="ball mr-2" :style="{ backgroundColor: SEAT_COLORS[item.look] }" />
      <span> {{ item.title }} </span>
    </li>
    <li v-for="type in types" :key="type" class="d-flex justify-center align-center px-4 pt-2 pt-md-0">
      <v-icon size="20" class="mr-2">
        {{ SEAT_TYPE_ICONS[type] }}
      </v-icon>
      <span> {{ SEAT_TYPE_NAMES[type] }} </span>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { SEAT_COLORS, SEAT_TYPE_ICONS, SEAT_TYPE_NAMES } from "@/utils/seatGrid";
import type { SeatLook, SpecialSeatType } from "@/utils/seatGrid";

interface Props {
  /** Seat Types in the Section, one line each. */
  types?: SpecialSeatType[];
}

const { types = [] } = defineProps<Props>();

defineOptions({
  name: "SeatSelectorCaptions",
});

const statuses: { look: SeatLook; title: string }[] = [
  { look: "available", title: "Livre" },
  { look: "reserved", title: "Reservada" },
  { look: "occupied", title: "Ocupada" },
  { look: "selected", title: "Selecionada" },
];
</script>

<style scoped>
ul.captions {
  .ball {
    width: 20px;
    height: 20px;
    border-radius: 50%;
  }
}
</style>
